import React, { useState, useContext, useCallback, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  Modal,
  TextInput,
  ActivityIndicator,
  ScrollView
} from 'react-native';
import { AuthContext } from '../context/AuthContext';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useFocusEffect } from '@react-navigation/native';
import CONFIG from '../config/Config';

// Bileşeni içe aktarıyoruz (Yolun doğru olduğundan emin ol)
import CustomAlert from '../components/CustomAlert'; 

export default function OdemelerScreen() {
  const { userToken }                   = useContext(AuthContext);
  const userInfo                        = userToken ? JSON.parse(userToken) : null;
  const [loading, setLoading]           = useState(false);
  const [payments, setPayments]         = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertConfig, setAlertConfig]   = useState({
    title: '',
    message: '',
    type: 'info',
    onConfirm: () => {},
    showCancel: false
  });

  const [tutar, setTutar] = useState('');
  const [aciklama, setAciklama] = useState('');
  const QUICK_TAGS = ["Kurye", "Market", "Bıçak Bileme", "Diğer"];
  const [isProtected, setIsProtected] = useState(false);
  const [currentPrefix, setCurrentPrefix] = useState("");

  const handleTagPress = (tag) => {
  if (tag === "Diğer") {
    setAciklama(""); // Diğer seçilirse temizle
    setIsProtected(false);
    setCurrentPrefix("");
  } else {
    const prefix = tag + " "; 
    setAciklama(prefix);
    setIsProtected(true);
    setCurrentPrefix(prefix); // Korunacak kelimeyi kaydet
  }
};

const fetchPayments = async () => {
  setLoading(true);
  try {
    const response = await fetch(`${CONFIG.API_BASE_URL}/odeme`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
      body: JSON.stringify({ action: "OdemeListele" })
    });


    // ÖNEMLİ: json() yapmadan önce ham metni alalım
    const rawText = await response.text();

    const result = JSON.parse(rawText);
    if (result.success) setPayments(result.data);

  } catch (error) {
    console.log("Liste yükleme hatası detay:", error);
  } finally {
    setLoading(false);
  }
};

  // 2. SAYFAYA HER GİRİLDİĞİNDE TETİKLENEN YAPI
  useFocusEffect(
    useCallback(() => {
      fetchPayments();
      // Sayfadan çıkarken bir şey temizlemek gerekirse buraya return eklenir
    }, [])
  );

  useEffect(() => { fetchPayments(); }, []);

  // Yardımcı Alert Fonksiyonu
  const showAlert = (config) => {
    setAlertConfig({
      ...config,
      onConfirm: () => {
        config.onConfirm?.();
        setAlertVisible(false);
      },
      onCancel: () => {
        setAlertVisible(false);
      }
    });
    setAlertVisible(true);
  };

  // Ödeme Silme (Yetki Kontrollü + CustomAlert)
const deletePayment = (item) => {

  const ekleyenKisiMi = userInfo?.ID === item.KasiyerID;
  const ustMakamMi    = userInfo?.Level > item.KasiyerLevel; 
  const yetkiliMi     = ekleyenKisiMi || ustMakamMi;

  console.log("Kendi Kaydım mı:", ekleyenKisiMi, "Üst Makam mıyım:", ustMakamMi);

  if (!yetkiliMi) {
    showAlert({
      title: "Yetki Yetersiz",
      message: "Bu harcamayı sadece ekleyen kişi veya kendisinden daha üst yetkideki personel silebilir.",
      type: "error"
    });
    return;
  }

  // 2. ADIM: Onay ve API Çağrısı (Aynen devam ediyor)
  showAlert({
    title: "Silme Onayı",
    message: `*${item.Aciklama}* kaydını silmek istediğinize emin misiniz?`,
    type: "warning",
    showCancel: true,
    confirmText: "EVET, SİL",
    onConfirm: async () => {
      setLoading(true);
      try {
        const response = await fetch(`${CONFIG.API_BASE_URL}/odeme`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-App-Env': CONFIG.ENV },
          body: JSON.stringify({
            action: "OdemeSil",
            KasiyerID: userInfo?.ID,
            KasiyerLevel: userInfo?.Level,
            OdemeID: item.ID
          })
        });

        const result = await response.json();
        if (result.success) {
          setPayments(prev => prev.filter(p => p.ID !== item.ID));
          showAlert({ title: "Başarılı", message: "Kayıt silindi.", type: "success" });
        } else {
          showAlert({ title: "Hata", message: result.message, type: "error" });
        }
      } catch (error) {
        showAlert({ title: "Hata", message: "Sunucu hatası!", type: "error" });
      } finally {
        setLoading(false);
      }
    }
  });
};

  // Yeni Ödeme Ekleme
  const handleAddPayment = async () => {
    if (!tutar || !aciklama) {
      showAlert({ 
        title: "Hata", 
        message: "Lütfen tutar ve açıklama alanlarını doldurun.", 
        type: "error" 
      });
      return;
    }

    setLoading(true);
    // Temizlenmiş açıklama (Boşlukları buduyoruz)
    const temizAciklama = aciklama.trim();

    try {
      const response = await fetch(`${CONFIG.API_BASE_URL}/odeme`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Env': CONFIG.ENV,
        },
        body: JSON.stringify({
          action: 'OdemeGir', // Yeni ödeme olduğunu bildiren bayrak
          tutar: parseFloat(tutar),
          aciklama: temizAciklama,
          KasiyerID: userInfo?.ID, // Genelde UserName benzersizdir
          KasiyerName: userInfo?.Name,
          KasiyerLevel: userInfo?.Level
        })
      });
      const tempText = await response.text();
      console.log("API Yanıtı (Ham):", tempText);

      // 404 ALIYORSAN BURASI HTML DÖNECEĞİ İÇİN JSON.PARSE HATA VERİR
      // O YÜZDEN ÖNCE STATUS KONTROLÜ YAPALIM
      if (response.status === 404) {
          showAlert({ title: "Hata", message: "Sunucu yolu bulunamadı (404). URL'yi kontrol edin.", type: "error" });
          setLoading(false);
          return;
      }

      const result = JSON.parse(tempText);

      if (result.success) {
        // API'den başarılı dönerse listeyi yenile ve modalı kapat
        showAlert({ 
          title: "Başarılı", 
          message: "Ödeme kaydı başarıyla eklendi.", 
          type: "success" 
        });
        
        // Listeyi güncellemek için tekrar fetch yapabilirsin
        fetchPayments(); 
        
        setModalVisible(false);
        setTutar('');
        setAciklama('');
      } else {
        showAlert({ 
          title: "Hata", 
          message: result.message || "Ödeme kaydedilemedi.", 
          type: "error" 
        });
      }
    } catch (error) {
      console.error("API Hata:", error);
      showAlert({ 
        title: "Bağlantı Hatası", 
        message: "Sunucuya bağlanılamadı.", 
        type: "error" 
      });
    } finally {
      setLoading(false);
    }
  };

const renderItem = ({ item }) => {
  // 1. KURAL: Bu kaydı ben mi ekledim? (ID kıyaslaması)
  const ekleyenKisiMi = userInfo?.ID === item.KasiyerID;

  // 2. KURAL: Benim yetkim, bu kaydı ekleyenden DAHA MI YÜKSEK?
  // Not: Sunucudan 'KasiyerLevel' alanının geldiğinden emin olmalısın.
  const ustMakamMi = userInfo?.Level > item.KasiyerLevel;

  // İkisinden biri doğruysa yetkilidir
  const yetkiliMi = ekleyenKisiMi || ustMakamMi;
  

  return (
    <View style={styles.card}>
      <View style={{ flex: 1 }}>
        {/* Sunucudan gelen 'Aciklama' */}
        <Text style={styles.cardDesc}>{item.Aciklama}</Text>
        {/* Sunucudan gelen 'KasiyerName' */}
        <Text style={styles.cardUser}>{item.KasiyerName}</Text>
      </View>
      
      {/* Sunucudan gelen 'Tutar' */}
      <Text style={styles.cardAmount}>
        {parseFloat(item.Tutar).toFixed(2)} ₺
      </Text>

      {yetkiliMi && (
        <TouchableOpacity onPress={() => deletePayment(item)} style={styles.deleteBtn}>
          <Ionicons name="trash" size={20} color="#ef4444" />
        </TouchableOpacity>
      )}
    </View>
  );
};



  return (
    <SafeAreaView style={styles.container}>
      {/* CustomAlert Bileşeni */}
      <CustomAlert 
        visible={alertVisible}
        {...alertConfig}
        onCancel={() => setAlertVisible(false)}
      />

      <View style={styles.header}>
        <Text style={styles.headerTitle}>Ödemeler</Text>
        <TouchableOpacity onPress={() => setModalVisible(true)}>
          <Ionicons name="add-circle" size={35} color="#10b981" />
        </TouchableOpacity>
      </View>

      <FlatList
        data={payments}
        renderItem={renderItem}
        keyExtractor={item => item.ID.toString()}
        contentContainerStyle={{ padding: 15 }}
      />

  <Modal visible={modalVisible} animationType="slide" transparent>
    <View style={styles.modalOverlay}>
      <View style={styles.modalContent}>
        <Text style={styles.modalTitle}>Yeni Ödeme</Text>
        
        <TextInput 
          style={styles.input} 
          placeholder="Tutar" 
          keyboardType="numeric" 
          value={tutar} 
          onChangeText={setTutar} 
        />

        {/* --- HIZLI ETİKETLER BAŞLANGIÇ --- */}
        <View style={styles.tagWrapper}>
          <Text style={styles.tagLabel}>Hızlı Şablonlar:</Text>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.tagScroll}>
            {QUICK_TAGS.map((tag, index) => (
              <TouchableOpacity 
                key={index} 
                style={styles.tagItem} 
                onPress={() => handleTagPress(tag)} // Yeni fonksiyonu çağırıyoruz
              >
                <Text style={styles.tagText}>{tag}</Text>
              </TouchableOpacity>
            ))}
          </ScrollView>
        </View>
        {/* --- HIZLI ETİKETLER BİTİŞ --- */}

        <TextInput 
          style={[styles.input, { height: 80, textAlignVertical: 'top' }]} 
          placeholder="Açıklama" 
          multiline 
          value={aciklama} 
          onChangeText={(text) => {
            if (isProtected) {
              // Eğer kullanıcı korumalı kısmı silmeye çalışırsa engelle
              if (text.startsWith(currentPrefix)) {
                setAciklama(text);
              }
            } else {
              // "Diğer" seçiliyse veya şablon seçilmemişse serbestçe yaz/sil
              setAciklama(text);
            }
          }} 
        />

        <View style={styles.buttonRow}>
          <TouchableOpacity style={styles.cancelBtn} onPress={() => setModalVisible(false)}>
            <Text style={styles.cancelBtnText}>İptal</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.saveBtn} onPress={handleAddPayment}>
            <Text style={styles.saveBtnText}>Kaydet</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  </Modal>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#f8fafc' },
  header: { flexDirection: 'row', justifyContent: 'space-between', padding: 20, backgroundColor: 'white', alignItems: 'center' },
  headerTitle: { fontSize: 24, fontWeight: '800', color: '#1e293b' },
  card: { flexDirection: 'row', backgroundColor: 'white', padding: 15, borderRadius: 16, marginBottom: 12, alignItems: 'center', elevation: 2 },
  cardDesc: { fontSize: 16, fontWeight: '700', color: '#334155' },
  cardUser: { fontSize: 12, color: '#94a3b8', marginTop: 2 },
  cardAmount: { fontSize: 18, fontWeight: '800', color: '#ef4444', marginRight: 15 },
  deleteBtn: { padding: 5 },
  modalOverlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center' },
  modalContent: { width: '85%', backgroundColor: 'white', borderRadius: 24, padding: 25 },
  modalTitle: { fontSize: 20, fontWeight: '800', marginBottom: 20, textAlign: 'center' },
  input: { borderBottomWidth: 1, borderBottomColor: '#e2e8f0', marginBottom: 20, padding: 10, fontSize: 16 },
  buttonRow: { flexDirection: 'row', gap: 10 },
  cancelBtn: { flex: 1, padding: 15, alignItems: 'center', backgroundColor: '#f1f5f9', borderRadius: 12 },
  saveBtn: { flex: 1, padding: 15, alignItems: 'center', backgroundColor: '#10b981', borderRadius: 12 },
  tagWrapper: {
    marginBottom: 15,
  },
  tagLabel: {
    fontSize: 12,
    color: '#64748b',
    marginBottom: 8,
    fontWeight: '600',
  },
  tagScroll: {
    flexDirection: 'row',
  },
  tagItem: {
    backgroundColor: '#f1f5f9', // Hafif gri/mavi ton
    paddingHorizontal: 15,
    paddingVertical: 8,
    borderRadius: 20,
    marginRight: 8,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },
  tagText: {
    color: '#334155',
    fontSize: 13,
    fontWeight: '500',
  },
  // Modal butonları için iyileştirme
  cancelBtn: {
    flex: 1,
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancelBtnText: {
    color: '#64748b',
    fontWeight: '600',
  },
  saveBtn: {
    flex: 2,
    backgroundColor: '#059669', // Kasap dükkanına yakışır güven veren bir yeşil
    padding: 15,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    elevation: 2,
  },
  saveBtnText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
  },
});